module.exports = __webpack_public_path__ + "static/media/8.5cba0c83.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/8.mp3
// module id = 484
// module chunks = 0